import axios from "axios";
import { store } from "../index";
import { apiClient } from "../axiosConfig";
import { logoutSagaAC } from "./systemActionCreators";

let accessToken: any = null;

export const getAccessToken = () => accessToken;

export const auth = async (payload: { email: string; password: string }) => {
  const path = "/token";

  const data = {
    username: payload.email,
    password: payload.password,
  };

  try {
    // @ts-ignore
    const response = await apiClient.post(path, data, { skipAuth: true });

    accessToken = response.data?.access_token
      ? response.data.access_token
      : null;

    return response;
  } catch (error) {
    if (error.response) {
      console.log(error);
      return error.response;
    } else if (error.request) {
      console.log(error);
      return error.request;
    } else {
      console.log(error);
      return error;
    }
  }
};

export const getRefreshToken = async (payload: { refreshToken: string }) => {
  const path = "/token/refresh";

  const data = { refresh_token: payload.refreshToken };

  return (
    apiClient
      // @ts-ignore
      .post(path, data, { skipAuth: true })
      .then((res) => {
        accessToken = res.data?.access_token ? res.data.access_token : null;
        return res;
      })
      .catch((error) => {
        if (error.response) {
          console.log(error);
          return error.response;
        } else if (error.request) {
          console.log(error);
          return error.request;
        } else {
          console.log(error);
          return error;
        }
      })
  );
};

export const getCurrentUser = async (token: string) => {
  const path = `${process.env.REACT_APP_BASE_API_URL}/user/user/current`;

  const config = { headers: { Authorization: `Bearer ${token}` } };

  try {
    const response = await apiClient.get(path, config);
    if (response.status === 401) {
      store.dispatch(logoutSagaAC());
    }

    return response;
  } catch (error) {
    if (error.response) {
      console.log(error);
      return error.response;
    } else if (error.request) {
      console.log(error);
      return error.request;
    } else {
      console.log(error);
      return error;
    }
  }
};

export const getCurrentUserWithoutHeadersMerchant = async (token: string) => {
  const path = `${process.env.REACT_APP_BASE_API_URL}/user/user/current`;

  const config = { headers: { Authorization: `Bearer ${token}` } };

  try {
    const response = await axios.get(path, config);
    if (response.status === 401) {
      store.dispatch(logoutSagaAC());
    }

    return response;
  } catch (error) {
    if (error.response) {
      console.log(error);
      return error.response;
    } else if (error.request) {
      console.log(error);
      return error.request;
    } else {
      console.log(error);
      return error;
    }
  }
};
